import { getRequest, putRequest } from "../api/methodsCfg";
import api from "../api/axiosCfg";

/**
 * Start an AI menu parsing job by uploading files.
 * Uses raw axios to handle multipart FormData with multiple files.
 * @param {number} restaurantId - Target restaurant ID
 * @param {File[]} files - Array of File objects (images/PDFs)
 * @returns {Object} { data: { jobId, importLogId }, status }
 */
export const startMenuImport = async (restaurantId, files) => {
  const formData = new FormData();
  formData.append("restaurantId", restaurantId);
  files.forEach((file) => {
    formData.append("menuFiles", file);
  });

  const response = await api.post("/ai-menu/parse", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return { data: response.data, status: response.status };
};

/**
 * Start an AI menu parsing job from a website URL.
 * @param {number} restaurantId - Target restaurant ID
 * @param {string} url - Restaurant website URL
 * @returns {Object} { data: { jobId, importLogId }, status }
 */
export const startMenuImportFromUrl = async (restaurantId, url) => {
  const formData = new FormData();
  formData.append("restaurantId", restaurantId);
  formData.append("urls", url);

  const response = await api.post("/ai-menu/parse", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return { data: response.data, status: response.status };
};

/**
 * Get the status of a menu parsing job.
 * @param {string} jobId - The job ID returned from startMenuImport
 * @returns {Object} { data: { jobId, state, progress, result, failedReason }, status }
 */
export const getImportJobStatus = async (jobId) => {
  const response = await getRequest(`/ai-menu/job/${jobId}`);
  return response;
};

/**
 * Get remaining AI import quota for the current user/restaurant.
 * @param {number} restaurantId - Restaurant ID
 * @returns {Object} { data: { remaining, limit, role }, status }
 */
export const getRemainingImports = async (restaurantId) => {
  const response = await getRequest(`/ai-menu/remaining/${restaurantId}`);
  return response;
};

/**
 * Admin-only: Unlock additional AI import for a restaurant.
 * @param {number} restaurantId - Restaurant ID
 * @param {number} incrementBy - Number of additional imports to allow (default 1)
 * @returns {Object} { data: { message, restaurantId, newLimit }, status }
 */
export const unlockImport = async (restaurantId, incrementBy = 1) => {
  const response = await putRequest(`/ai-menu/unlock/${restaurantId}`, {
    incrementBy,
  });
  return response;
};
